export const clickTab = (selector) => {
    const tabElement = document.querySelector(selector)

    if (tabElement && !tabElement.classList.contains('react-tabs__tab--selected')) {
        tabElement.click()
    }

    return tabElement
}

export const clickTabAndMoveNext = (tourManager, tabSelector) => () => {
    clickTab(tabSelector)
    setTimeout(() => tourManager.moveNext(), 150)
}

export const clickTabAndMovePrev = (tourManager, tabSelector) => () => {
    clickTab(tabSelector)
    setTimeout(() => tourManager.movePrevious(), 150)
}

export const setReactInputValue = (input, value) => {
    if (!input) return

    const setter = Object.getOwnPropertyDescriptor(window.HTMLInputElement.prototype, 'value').set
    setter.call(input, value)
    input.dispatchEvent(new Event('input', { bubbles: true }))
}

export const setReactTextareaValue = (textarea, value) => {
    if (!textarea) return

    const setter = Object.getOwnPropertyDescriptor(window.HTMLTextAreaElement.prototype, 'value').set
    setter.call(textarea, value)
    textarea.dispatchEvent(new Event('input', { bubbles: true }))
}

export const setReactSelectValue = (select, value) => {
    if (!select) return

    const setter = Object.getOwnPropertyDescriptor(window.HTMLSelectElement.prototype, 'value').set
    setter.call(select, value)
    select.dispatchEvent(new Event('change', { bubbles: true }))
}

export const openMenuAndGet = (parentId, groupId, selector) => {
    const parent = document.querySelector(`#${parentId}`)
    const submenu = document.querySelector(`#${groupId}`)

    if (parent && submenu && !submenu.classList.contains('hdv-menu-item-grupo-open')) {
        parent.click()
    }

    return document.querySelector(selector)
}

export const selectProtocol = (protocol) => {
    const radio = document.querySelector(`[data-tour="protocol-${protocol}"] input`)

    if (radio && !radio.checked) {
        radio.click()
    }
}

export const selectFirstReactSelectOption = (containerSelector) =>
    new Promise((resolve) => {
        const container = document.querySelector(containerSelector)
        if (!container) {
            resolve(false)
            return
        }

        const control = container.querySelector('.rs__control')
        if (!control) {
            resolve(false)
            return
        }

        control.dispatchEvent(new MouseEvent('mousedown', { bubbles: true }))

        setTimeout(() => {
            const option = document.querySelector('.rs__option')
            if (option) {
                option.click()
                resolve(true)
                return
            }
            resolve(false)
        }, 120)
    })

export const selectFirstEnabledReactSelectOption = (containerSelector, ignoredLabels = []) =>
    new Promise((resolve) => {
        const container = document.querySelector(containerSelector)
        if (!container) {
            resolve(false)
            return
        }

        const control = container.querySelector('.rs__control')
        if (!control) {
            resolve(false)
            return
        }

        control.dispatchEvent(new MouseEvent('mousedown', { bubbles: true }))

        setTimeout(() => {
            const options = Array.from(document.querySelectorAll('.rs__option'))
            const normalizedIgnored = ignoredLabels.map((label) => label.toLowerCase())

            const availableOption = options.find((option) => {
                const isDisabled =
                    option.classList.contains('rs__option--is-disabled') ||
                    option.getAttribute('aria-disabled') === 'true'
                const label = (option.textContent || '').trim().toLowerCase()
                return !isDisabled && !normalizedIgnored.includes(label)
            })

            if (availableOption) {
                availableOption.click()
                resolve(true)
                return
            }

            control.dispatchEvent(new KeyboardEvent('keydown', { bubbles: true, key: 'Escape' }))
            resolve(false)
        }, 150)
    })

export const clickSaveAndWaitSuccess = (tourManager, saveSelector) => {
    document.querySelector(saveSelector)?.click()

    return tourManager.waitForElement(() => {
        const modalBody = document.querySelector('.modal-body, .hdv-aviso-body, [class*="aviso"]')
        if (modalBody && /sucesso/i.test(modalBody.textContent || '')) return modalBody

        const successTextElement = Array.from(document.querySelectorAll('body *')).find(
            (leafElement) =>
                leafElement.children.length === 0 &&
                /sucesso/i.test(leafElement.textContent || '')
        )
        return successTextElement || null
    }, 8000)
}

export const dismissSuccessModal = () => {
    const buttons = Array.from(document.querySelectorAll('button, a'))
    const closeButton = buttons.find((button) =>
        /fechar|continuar|ok|editar/i.test((button.textContent || '').trim())
    )
    closeButton?.click()
}
